import { generateStripeState } from '../helper'

const options = {
  api: {
    list: () => `/api/stripe/tax-rates`,
    update: ({ id }) => `/api/stripe/tax-rate/${id}`,
    create: () => `/api/stripe/tax-rate`,
    get: ({ id }) => `/api/stripe/tax-rate/${id}`,
  },
  state: {
    collectionName: 'taxRates'
  },
  getters: {
    getPagination: 'getTaxRatePagination',
    getCollection: 'getTaxRates'
  },
  actions: {
    list: 'listTaxRates',
    update: 'updateTaxRate',
    create: 'createTaxRate',
    get: 'getTaxRate',
  },
  mutationKey: 'TAX_RATES',
}

const {
  state: stripeState,
  getters: stripeGetters,
  actions: stripeActions,
  mutations: stripeMutations
} = generateStripeState(options)

export default {
  state: {
    ...stripeState
  },
  getters: {
    ...stripeGetters
  },
  mutations: {
    ...stripeMutations
  },
  actions: {
    ...stripeActions
  }
}
